import { createAction } from 'redux-actions';

export const getPostsAction = createAction('COMMUNITY_BOARD_GET_POSTS');
export const getPostAction = createAction('COMMUNITY_BOARD_GET_POST');
export const createPostAction = createAction('COMMUNITY_BOARD_CREATE_POST');
export const updatePostAction = createAction('COMMUNITY_BOARD_UPDATE_POST');
export const deletePostAction = createAction('COMMUNITY_BOARD_DELETE_POST');
export const addPostReactionAction = createAction('COMMUNITY_BOARD_ADD_POST_REACTION');
export const deletePostReactionAction = createAction('COMMUNITY_BOARD_DELETE_POST_REACTION');
export const createCommentAction = createAction('COMMUNITY_BOARD_CREATE_COMMENT');
export const updateCommentAction = createAction('COMMUNITY_BOARD_UPDATE_COMMENT');
export const deleteCommentAction = createAction('COMMUNITY_BOARD_DELETE_COMMENT');
export const getCommentsAction = createAction('COMMUNITY_BOARD_GET_COMMENTS');
export const reportPostAction = createAction('COMMUNITY_BOARD_REPORT_POST');
export const reportCommentAction = createAction('COMMUNITY_BOARD_REPORT_COMMENT');
export const addCommentReactionAction = createAction('COMMUNITY_BOARD_ADD_COMMENT_REACTION');
export const deleteCommentReactionAction = createAction('COMMUNITY_BOARD_DELETE_COMMENT_REACTION');

export const getCommunityTopicsAction = createAction('COMMUNITY_BOARD_GET_COMMUNITY_TOPICS');

export const setCommentReactionAction = createAction('COMMUNITY_BOARD_SET_COMMENT_REACTION');
export const setDeleteCommentReactionAction = createAction('COMMUNITY_BOARD_SET_DELETE_COMMENT_REACTION');

export const setPostListReactionAction = createAction('COMMUNITY_BOARD_SET_POST_LIST_REACTION');
export const setDeletePostListReactionAction = createAction('COMMUNITY_BOARD_SET_DELETE_POST_LIST_REACTION');

export const setPostReactionAction = createAction('COMMUNITY_BOARD_SET_POST_REACTION');
export const setDeletePostReactionAction = createAction('COMMUNITY_BOARD_SET_DELETE_POST_REACTION');

export const clearPostAction = createAction('COMMUNITY_BOARD_CLEAR_POST');
export const clearCommentsAction = createAction('COMMUNITY_BOARD_CLEAR_COMMENTS');
